import { render, staticRenderFns } from "./bookingStrandedWarning.vue?vue&type=template&id=ee2f4410&scoped=true&"
import script from "./bookingStrandedWarning.vue?vue&type=script&lang=js&"
export * from "./bookingStrandedWarning.vue?vue&type=script&lang=js&"
import style0 from "./bookingStrandedWarning.vue?vue&type=style&index=0&id=ee2f4410&lang=less&scoped=true&"
import style1 from "./bookingStrandedWarning.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2f4410",
  null
  
)

export default component.exports